(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion) return;

  var players = document.querySelectorAll('[data-has-video] .riwayat-media__video');
  if (!players.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;
        if (entry.isIntersecting) {
          if (!el.getAttribute('src') && el.querySelector('source')) {
            el.load();
          }
          var playPromise = el.play();
          if (playPromise && playPromise.catch) {
            playPromise.catch(function () {});
          }
          el.classList.add('is-ready');
        } else {
          el.pause();
        }
      });
    },
    { threshold: 0.25 }
  );

  players.forEach(function (video) {
    observer.observe(video);
  });
})();
